<template lang="pug">
    el-dialog(title="成绩管理",width="95%", :visible.sync='visible' :append-to-body="true" :modal-append-to-body='false')
        el-form(:model="ruleForm",:inline="true",label-suffix=":" label-width="90px")
            el-card(shadow="never")
                el-form-item(label="比赛ID" prop="matchId")
                    div.width_label {{ruleForm.matchId}}
                el-form-item(label="比赛名称" prop="matchName")
                    div.width_label {{ruleForm.matchName}}
                el-form-item(label="比赛类别")
                    div.width_label 俱乐部公开赛
                el-form-item(label="主办单位" prop="orgName")
                    div.width_label {{ruleForm.orgName}}
                el-form-item(label="比赛场地")
                    div.width_label {{ruleForm.placeName}}
                br
                el-form-item(label="赛事类型" prop="ctType")
                    div.width_label(v-if="ruleForm.ctType === 5") 月度赛-资格赛
                    div.width_label(v-if="ruleForm.ctType === 6") 月度赛-级别赛
                    div.width_label(v-if="ruleForm.ctType === 4") 年度总决赛
                el-form-item(label="签位" prop="applySize")
                    div.width_label {{ruleForm.joinCount}}/{{ruleForm.applySize}} 签
                el-form-item(label="比赛时间")
                    div.width_label {{ruleForm.matchStartTime}}
                el-form-item(label="状态")
                    div.width_label(v-if="ruleForm.matchStatus == 2") {{ruleForm.statusName}}
                    div.width_label(v-if="ruleForm.matchStatus == 3") 已取消
                    div.width_label(v-if="ruleForm.matchStatus == 4") 已结束
        el-row(style="padding-top:10px")
            el-col(:span="24")
                el-card(shadow="never")
                    div(slot="header")
                        font.font_label 比赛成绩录入
                    div
                        el-table(:data="gradeData" border)
                            el-table-column(prop="name" label="俱乐部" align="center")
                            el-table-column(prop="chairman" label="会长" align="center")
                            el-table-column(prop="mobile" label="会长账号" align="center")
                            el-table-column(prop="rank" label="排名" align="center")
                                template(slot-scope="scope")
                                    el-input-number(v-model="scope.row.rank" :min="0")
                            el-table-column(prop="score" label="积分" align="center" :min="0")
                                template(slot-scope="scope")
                                    el-input-number(v-model="scope.row.score")
                            //- 临时加功能
                            el-table-column(prop="score" label="队员积分" align="center" :min="0")
                                template(slot-scope="scope")
                                    el-button(type="text" @click="clubMemberInputScore(scope.row)") 编辑
                        //- 二期改造内容,暂时先屏蔽
                        //- div(class="marginBottom")
                        //-     el-button(@click="chooseRound()") 1R
                        //-     el-button(@click="chooseRound()") 2R
                        //-     el-button(@click="chooseRound()") 3R
                        //-     el-button(@click="chooseRound()") 4R
                        //-     el-button(@click="chooseRound()") 5R
                        //-     el-button(@click="chooseRound('leaderBoard')" type="primary") add排行榜
                        //- el-table(v-if="isRoundView" :data="gradeData" border)
                        //-     el-table-column(prop="name" label="add比赛时间" align="center")
                        //-     el-table-column(prop="name" label="add姓名" align="center")
                        //-     el-table-column(prop="name" label="add让分" align="center")
                        //-     el-table-column(prop="name" label="add本轮得分" align="center")
                        //-     el-table-column(prop="name" label="add操作" align="center" width="300")
                        //-         template(slot-scope="scope")
                        //-             el-button(type="text" @click="updateGrade") 修改成绩
                        //-             el-button(type="text" @click="viewDispute") 查看争议
                        //-             el-button(type="text" @click="viewPhotos") 查看照片打卡
                        //- el-table(v-if="!isRoundView" :data="gradeData" border)
                        //-     el-table-column(prop="name" label="add名次" align="center")
                        //-     el-table-column(prop="name" label="add姓名" align="center")
                        //-     el-table-column(prop="name" label="add总得分" align="center")
                        //-     el-table-column(prop="name" label="add积分" align="center")
                        //-     el-table-column(prop="name" label="add升级点数" align="center")
        span.dialog-footer(slot="footer")
            el-button(@click="comfirmClick" type="primary") 确 定
            el-button(@click="visible=false") 取 消
        updateGrade(v-if='updateGradeVisible' ref="updageGrade")
        viewDispute(v-if='viewDisputeVisible' ref="viewDispute")
        viewPhotos(v-if='viewPhotosVisible' ref="viewPhotos")
        MemberInput(v-if='clubMemberInputScoreVisible' ref="memberInput")
</template>
<script>
import UpdateGrade from './update-grade'
import ViewDispute from './view-dispute'
import ViewPhotos from './view-photos'
import MemberInput from './member-input'
export default{
    data () {
        return {
            visible: false,
            ruleForm: {
                id: null,
                matchType: '1'
            },
            gradeData: [],
            loading: null,
            isRoundView: true,
            updateGradeVisible: false,
            viewDisputeVisible: false,
            viewPhotosVisible: false,
            clubMemberInputScoreVisible: false
        }
    },
    components: {
        UpdateGrade,
        ViewDispute,
        ViewPhotos,
        MemberInput
    },
    methods: {
        // 队员积分录入
        clubMemberInputScore (row) {
            this.clubMemberInputScoreVisible = true
             this.$nextTick(() => {
                this.$refs.memberInput.init(row, this.ruleForm.id)
            })
        },
        // 修改成绩操作
        updateGrade () {
            this.updateGradeVisible = true
            this.$nextTick(() => {
                this.$refs.updageGrade.init()
            })
        },
        // 查看争议
        viewDispute () {
            this.viewDisputeVisible = true
            this.$nextTick(() => {
                this.$refs.viewDispute.init()
            })
        },
        // 查看照片打卡
        viewPhotos () {
            this.viewPhotosVisible = true
            this.$nextTick(() => {
                this.$refs.viewPhotos.init()
            })
        },
        // 成绩管理录入数据查看事件
        chooseRound (type) {
            if (type) {
                this.isRoundView = false
            } else {
                this.isRoundView = true
            }
        },
        init (row) {
            this.visible = true
            this.gradeData = null
            //回选
            this.$http({
                url: this.$http.adornUrl(`/ctCompetition/getId/` + row.id),
                method: 'get'
            }).then((data) => {
                if (data && data.code === 0) {
                    this.ruleForm = data.bean
                    let joinCount = this.ruleForm.joinCount//已报名参赛人员的人数
                    let applySize = this.ruleForm.applySize//赛事签位数
                    let date1 = new Date().getTime()
                    let date2 = new Date(this.ruleForm.matchStartTime).getTime()
                    let date3 = new Date(this.ruleForm.matchSignStartTime).getTime()
                    let date4 = new Date(this.ruleForm.matchSignEndTime).getTime()
                    if (date1 < date3) {
                        this.ruleForm.statusName = '未开始'
                    } else if (date1 >= date3 && date1 <= date4 && joinCount < applySize) {
                        this.ruleForm.statusName = '报名中'
                    } else if (date1 >= date3 && date1 <= date4 && joinCount >= applySize) {
                        this.ruleForm.statusName = '报满可替'
                    } else if (date1 > date4 && date1 < date2) {
                        this.ruleForm.statusName = '报名结束'
                    } else if (date1 >= date2) {
                        this.ruleForm.statusName = '已开赛'
                    }
                    this.ruleForm.orderForm = 1
                }
            }).then(() => {
                this.getEnrollData(row.id)
            })
        },
        orderChange () {
            this.getEnrollData(this.ruleForm.id)
        },
        //列表刷新
        getEnrollData (id) {
            let params = { 'ctId': id }
            if (this.ruleForm.projectType == 1) {
                //单打默认排序,按照参赛人员年度积分倒序（年度积分为今日之前365天积分和），多的排在前面。
                params.orderForm = 0
            } else if (this.ruleForm.projectType == 2) {
                //双打默认按级别和-积分和排序
                params.orderForm = 1
            }
            this.$http({
                url: this.$http.adornUrl(`/elEnroll/getClubScoreList`),
                method: 'post',
                data: params
            }).then((data) => {
                if (data && data.code === 0) {
                    // this.gradeData = [{ 'name': '休斯顿火箭' }] // test
                    this.gradeData = data.list
                    for (let i of this.gradeData) {
                        if (i.score == null) {
                            i.score = undefined
                        }
                        if (i.rank == null) {
                            i.rank = undefined
                        }
                    }
                }
            })
        },
        openFullScreen () {
            this.loading = this.$loading({
                lock: true,
                text: '加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
        },
        //提交事件
        comfirmClick () {
            let submitData = []
            //封装提交数据
            let flag = false
            for (let i of this.gradeData) {
                if (!i.rank) {
                    this.$message.error('请输入排名!')
                    flag = true
                    return
                }
                if (!i.score && i.score != 0) {
                    this.$message.error('请输入积分!')
                    flag = true
                    return
                }
                submitData.push({
                    id: i.scoreId,
                    matchInfoId: this.ruleForm.id, //赛事id
                    matchType: 2, //1:分级赛
                    enrollId: i.id, //报名id
                    participantInfoId: i.participantInfoId, //报名俱乐部id
                    participantInfoRealName: i.enrollUserName, //报名人姓名
                    rank: i.rank,
                    score: i.score
                })
            }
            if (flag) {
                this.$message.error('请输入全部成绩信息!')
                return
            }
            this.openFullScreen()
            this.$http({
                url: this.$http.adornUrl(`/ctScore/saveOrUpdate`),
                method: 'post',
                data: submitData
            }).then((data) => {
                if (data && data.code === 0) {
                    this.$message({
                        message: '操作成功',
                        type: 'success',
                        duration: 1500,
                        onClose: () => {
                            this.visible = false
                            this.$emit('refreshDataList')
                        }
                    })
                } else {
                    this.$message.error('添加失败!')
                }
                this.loading.close()
            })
        }
    }
}
</script>
<style scoped>
</style>
